import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  display: ${({ isShow }) => {
    return isShow ? 'block' : 'none';
  }};

  .container_modal_wrapper {
    margin: auto;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 101;
    background-color: rgba(17, 29, 52, 0.33);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    ${(props) => {
      return (
        !props.useBackdrop &&
        css`
          -ms-overflow-style: none; /* Internet Explorer 10+ */
          scrollbar-width: none; /* Firefox */
          &::-webkit-scrollbar {
            width: 0; /* Remove scrollbar space */
            background: transparent; /* Optional: just make scrollbar invisible */
          }
          /* Optional: show position indicator in red */
          &::-webkit-scrollbar-thumb {
            width: 0;
          }
        `
      );
    }}

    .container_modal_content {
      max-width: ${({ width }) => {
        if (typeof width === 'string') {
          if (width?.includes('%')) return width;
        }
        return width ? `${width}px` : '600px';
      }};
      min-width: ${({ minWidth }) => {
        return minWidth ? `${minWidth}px` : 'unset';
      }};
      background-color: white;
      margin: auto;
      margin-top: 80px;
      margin-bottom: 84px;
      border-radius: 12px;
      z-index: 100;
    }
    .component_header {
      display: flex;
      justify-content: space-between;
      padding: 24px;
      align-items: center;
      .component_header_title {
        display: flex;
        flex-direction: column;
        row-gap: 4px;
      }
      .component_header_close {
        cursor: pointer;
        color: rgba(0, 0, 0, 0.65);
        font-size: 18px;
      }
    }
    .component_body {
      padding: 0 24px;
    }
    .component_footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 36px;
      background-color: ${color.grey3};
      padding: 12px 20px;
      border-radius: 12px;

      button {
        box-shadow: none;
      }
      button:first-child {
        margin-right: 8px;
      }
    }
  }

  .component_empty_footer {
    height: 36px;
  }
`;

export default Wrapper;
